<template>
<v-container fluid class="pa-0">
    <v-text-field
        append-icon="mdi-magnify" label="Recherche"
        solo single-line hide-details clearable v-model="search" class="ma-4 pa-0">
    </v-text-field>
    <v-card class="ma-4">
    <v-data-table v-bind:headers="headers" :items="items" item-key="sta_id" :search="search"
        items-per-page-text="Lignes par page" :items-per-page-options="pagination.rowsPerItem">
        <template v-slot:[`item.tem_sta_id`]="{ item }">
            <v-chip small outlined label>{{ stateListById[item.tem_sta_id].sta_label }}</v-chip>
        </template>
        <template v-slot:[`item.tem_id`]="{ item }">
            <v-btn outlined small color="grey" class="ml-2 elevation-1" :to="'/themes/' + item.tem_id + ''">
                <v-icon left class="mr-2">mdi-pencil</v-icon>Modifier
            </v-btn>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        De {{ pageStart }} à {{ pageStop }}
        </template>
        <template slot="no-data">
        <v-alert :value="true" color="error" icon="mdi-alert">
            Aucune données pour ce tableau
        </v-alert>
        </template>
    </v-data-table>
    </v-card>
</v-container>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useTypeStore } from '@/stores/type'
import { useStateStore } from '@/stores/state'
import { useThemeStore } from '@/stores/theme'

export default {
    name: 'themes-list',
    props: [],
    computed: {
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useStateStore, {stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
        ...mapState(useThemeStore, {itemList: 'itemList', metaItems: 'metaItems' }),
        pages () {
            if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null ) return 0
            return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
        },
    },
    data () {
        return {
            max25chars: (v) => v.length <= 25 || 'Trop de charactères',
            tmp: '',
            saveProgress: false,         // Enregistrement en cours...
            search: '',
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            headers: [
            { text: 'Nom', align: 'left', value: 'tem_label'},
            { text: 'Code', align: 'left', value: 'tem_code'},
            { text: 'Statut', align: 'left', value: 'tem_sta_id'},
            { text: 'Action', align: 'right', value: 'tem_id'},
            ],
            items: [],
            temId: 0,
            themeModal: false
        }
    },
    mounted: function (){
        this.getThemeList()
    },
    methods: {
        ...mapActions(useThemeStore, { fetchItems: 'fetchItems' }),
        getThemeList(){
            this.$http.get( '/themes/?per_page=false' )
            .then( (response) => {
                if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                    this.items = response.data.data
                }
            })
        },
        goRoute(id){
            this.$router.push({ path: '/themes/' + id + '/objtype' })
        },
        switchModal(name, mode, refresh){
            name    = name || 'themeModal'
            mode    = mode || 0
            refresh = refresh || false
            this[name] = mode
            if( refresh ){
                this.getThemeList()
            }
        },
        getCacheType () {
            const typeStore = useTypeStore()
            return typeStore.itemListByGroup
        },
        getCacheState () {
            const stateStore = useStateStore()
            return stateStore.itemListByGroup
        }
    },
    components: {
        
    },
}
</script>

<style lang="css">

</style>